import { render } from "./AddPublicationPage.vue?vue&type=template&id=3bf2d51b&ts=true"
import script from "./AddPublicationPage.vue?vue&type=script&lang=ts"
export * from "./AddPublicationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__